export const HelpCircleIcon = ({ ...props }: React.ComponentProps<"svg">) => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_71_2712)">
      <path
        d="M8.05992 10C8.21665 9.55444 8.52602 9.17873 8.93322 8.93942C9.34042 8.7001 9.81918 8.61262 10.2847 8.69247C10.7502 8.77232 11.1725 9.01434 11.4766 9.37568C11.7808 9.73702 11.9473 10.1943 11.9466 10.6667C11.9466 12 9.94659 12.6667 9.94659 12.6667M9.99992 15.3333H10.0066M16.6666 12C16.6666 15.6819 13.6818 18.6667 9.99992 18.6667C6.31802 18.6667 3.33325 15.6819 3.33325 12C3.33325 8.3181 6.31802 5.33333 9.99992 5.33333C13.6818 5.33333 16.6666 8.3181 16.6666 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_71_2712">
        <rect width="16" height="16" fill="white" transform="translate(2 4)" />
      </clipPath>
    </defs>
  </svg>
);
